import { setLength, setWidth } from '../plan/planRootSlice';
import { addManhole, removeManhole } from '../lid/lidSlice';
import { setStockVaultSize } from '../vault/vaultSlice';
import { setStockFloorSize } from '../floor/floorSlice';
import { getManholeDefinitions } from '../../containers/Plan/Configuration/Lid/lidElements';
import uuid from "react-uuid";

// d: { length: number, width: number }
export const applyStandardVault = (d, lid, stockVault, stockFloor) => (dispatch) => {
  const getManholeDefinition = () => getManholeDefinitions(lid.type)[0];

  // Clear previous configuration if needed
  if (lid && lid.manholes.length > 0) {
    dispatch(removeManhole({id: lid.manholes[0].id}));
  }

  // Update dimensions
  dispatch(setLength(d.length));
  dispatch(setWidth(d.width));

  // Handle manhole calculations if a lid exists
  if (lid) {
    const manholeDef = getManholeDefinition();
    if (manholeDef) {
      const getManholeWidth = () =>
        lid.type === 'subfloor'
          ? Math.ceil(d.length / manholeDef.width) * manholeDef.width
          : Math.floor((d.length + 8) / manholeDef.width) * manholeDef.width;

      const widthCalculated = getManholeWidth();
      const manhole = {
        ...manholeDef,
        id: uuid(),
        x: (d.length - widthCalculated) / 2,
        y: (d.width - manholeDef.height) / 2,
        width: widthCalculated,
      };

      dispatch(addManhole({manhole: manhole}));
    }
  }

  // Update stock vault size if needed
  if (stockVault) {
    dispatch(setStockVaultSize(`${d.length}x${d.width}`));
  }
  if (stockFloor) {
    dispatch(setStockFloorSize(`${d.length}x${d.width}`));
  }
};